<div class="m-inplace-edit"
     :class="{'m--has-erreur': error && propEditMode,
              'm--is-edit-mode': propEditMode && isMqMinS }"
     :style="propPadding"
     @click="emitClick">
    <slot name="readMode"
          v-if="!propEditMode || !isMqMinS"></slot>
    <template v-if="isMqMinS">
        <transition duration="300">
            <form v-show="propEditMode"
                  :aria-hidden="!propEditMode">
                <slot name="editMode"
                      v-if="propEditMode"></slot>
                <m-accordion-transition>
                    <div class="m-inplace-edit__buttons-wrap"
                         v-if="propEditMode">
                        <div class="m-inplace-edit__buttons">
                            <m-button :waiting="waiting"
                                      ref="confirm-control"
                                      skin="primary"
                                      @click.stop="onConfirm">
                                <m-i18n k="m-inplace-edit:save"></m-i18n>
                            </m-button>
                            <m-button :disabled="waiting"
                                      ref="cancel-control"
                                      skin="secondary"
                                      @click.stop="onCancel">
                                <m-i18n k="m-inplace-edit:cancel"></m-i18n>
                            </m-button>
                        </div>
                    </div>
                </m-accordion-transition>
            </form>
        </transition>
    </template>
    <template v-if="!isMqMinS">
        <m-overlay ref="overlay"
                   :open="propEditMode"
                   @close="onCancel"
                   @save="onConfirm"
                   @portal-after-open="emitMobileAfterOpen"
                   @portal-after-close="emitMobileAfterClose">
            <h2 class="m-edit-inplace__title"
                slot="header">{{ title }}</h2>
            <form>
                <slot name="editMode"></slot>
            </form>
        </m-overlay>
    </template>
</div>
